import { apiRequest } from "../util/apiUtils";

export const reportList = async (params) => {
  try {
    const res = await apiRequest("get", `contact-us/list`, {
      queries: { ...params, type: "report" },
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const reportDetails = async (params) => {
  try {
    const res = await apiRequest("get", `contact-us/detail/${params?.id}`, {});

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const reportAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `contact-us/${payload?.id ? "edit" : "add"}`,
      {
        body: { ...payload, type: "report" },
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const reportDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `contact-us/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const reportStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `contact-us/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const reportOrdering = async (payload) => {
  try {
    const res = await apiRequest("patch", `contact-us/ordering`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const reportCountList = async (params) => {
  try {
    const res = await apiRequest("get", `organization/reporting/dashboard`, {
      queries: params,
    });
    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const reportExport = async (payload) => {
  try {
    const res = await apiRequest(
      "post",
      `reporting/export`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const exportList = async (params) => {
  try {
    const res = await apiRequest("get", `reporting/export/list`, {
      queries: { ...params },
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
